import { defineMutator } from '@rocicorp/zero';
import * as z from 'zod';
import { assertCan } from '../../utils.js';
import { createMedicationProfile } from './utils/index.js';
import { AddMedicationProfileSchema } from './utils/schemas.js';
/**
 * Creates a single medication profile (plus its stability rules and reconstitution diluents) for an already-existing drug catalog item.
 *
 * The `id` is optional: when supplied by the client the profile can be selected immediately after the optimistic client mutation, without waiting for the sync.
 */
export const AddMedicationProfileInputSchema = AddMedicationProfileSchema.extend({
    drugCatalogItemId: z.uuidv7().nonempty(),
});
export const medicationProfiles = {
    add: defineMutator(AddMedicationProfileInputSchema, async ({ ctx, tx, args }) => {
        assertCan(ctx, 'catalogue.manage');
        await createMedicationProfile(tx, { ...args, drugItemId: args.drugCatalogItemId }, { createdAt: Date.now(), createdBy: ctx.user.id });
    }),
};
//# sourceMappingURL=medication-profile.mutators.js.map